import formHelper from './form-helper';

class LabelAnimation {
  constructor (form) {
    this.FORM_ITEM_FOCUS_CLASS = 'focused';
    this.LABEL_POSITION_CLASS = 'top';

    this.inputs = formHelper.focusableInputs(form.elements);
  }

  setup () {
    this.inputs.forEach(input => {
      const formItem = input.closest('[data-form-element]');
      const label = formItem.querySelector('label');

      input.addEventListener('input', (e) => {
        if (e.target.value === '') {
          return false;
        }
        this.checkMoveLabelToTop(formItem, label);
      });
      input.addEventListener('animationstart', () => this.checkMoveLabelToTop(formItem, label));
      input.addEventListener('focusin', () => this.checkMoveLabelToTop(formItem, label));
      input.addEventListener('change', () => {
        if (input.value !== '' || this.isAutofilled(input)) {
          this.checkMoveLabelToTop(formItem, label);
        }
      });

      input.addEventListener('focusout', () => this.checkMoveLabelToInput(formItem, label, input));

      if (input.value !== '') {
        this.checkMoveLabelToTop(formItem, label);
      }
    });

    // Handle browser back button navigation and cached page loads
    // Re-check input values when page is shown
    window.addEventListener('pageshow', () => {
      this.recheckInputValues();
    });

    // Multiple checks at staggered intervals to catch late autofill/value restoration
    // Slow networks may restore values after initial 50ms
    [50, 100, 200, 400, 800, 1600].forEach(delay => {
      setTimeout(() => {
        this.recheckInputValues();
      }, delay);
    });
  }

  recheckInputValues () {
    this.inputs.forEach(input => {
      const formItem = input.closest('[data-form-element]');
      const label = formItem.querySelector('label');
      // Check if input has value OR is autofilled (for password fields, browsers may not expose value)
      if (input.value !== '' || this.isAutofilled(input)) {
        this.checkMoveLabelToTop(formItem, label);
      }
    });
  }

  isAutofilled (input) {
    // Detect browser autofill using CSS pseudo-selectors
    try {
      return input.matches(':-webkit-autofill') || input.matches(':autofill');
    } catch (e) {
      return false;
    }
  }

  checkMoveLabelToTop (formItem, label) {
    formItem.classList.add(this.FORM_ITEM_FOCUS_CLASS);

    if (label.dataset['shrink'] !== 'true') {
      label.classList.add(this.LABEL_POSITION_CLASS);
    }
  }

  checkMoveLabelToInput (formItem, label, input) {
    formItem.classList.remove(this.FORM_ITEM_FOCUS_CLASS);

    if (label.dataset['shrink'] !== 'true' && !input.value) {
      label.classList.remove(this.LABEL_POSITION_CLASS);
    }
  }
}

// Auto-initialize label animation for all forms on the page
// This runs early and independently of any module initialization
function initializeLabelAnimation () {
  document.querySelectorAll('form').forEach(form => {
    const labelAnimation = new LabelAnimation(form);
    labelAnimation.setup();
  });
}

// Initialize immediately on all currently available forms
// This runs synchronously as soon as the script loads, not waiting for DOMContentLoaded
initializeLabelAnimation();

export default LabelAnimation;
